import { Button, ButtonProps } from '../../components'

import { useWizardContext } from './Wizard'

export const Back = (props: ButtonProps) => {
  const { back } = useWizardContext()
  return <Button type="button" variant="outline" onClick={back} {...props} />
}
